<template>
    
    <Card class="w-full">
        <template #title>
            Redefinição de senha
        </template>
        <template #content>
            <form @submit.prevent="login(form)">
                <div class="field mt-4">
                    <FloatLabel>
                        <Password id="senha" v-model="form.senha" class="w-full" inputClass="w-full" toggleMask />
                        <label for="senha">Nova Senha</label>
                    </FloatLabel>
                    <div class="text-xs text-red-500">{{ errors['senha'] }}</div>
                </div>
                <div class="field mt-4">
                    <FloatLabel>
                        <Password id="senha_confirma" v-model="form.senha_confirma" class="w-full" inputClass="w-full" :feedback="false" toggleMask />
                        <label for="senha_confirma">Confirmar Senha</label>
                    </FloatLabel>
                    <div class="text-xs text-red-500">{{ errors['senha_confirma'] }}</div>
                </div>
                <Button 
                    type="submit" 
                    label="Entrar" 
                    icon="pi pi-check" 
                    class="w-full mt-4" 
                    :loading="isLoading" />
            </form>
        </template>
    </Card>
</template>

<script>
import Card from 'primevue/card';
import FloatLabel from 'primevue/floatlabel';
import InputText from 'primevue/inputtext';
import Password from 'primevue/password';
import Button from 'primevue/button';

import Auth from '@/service/auth.js';
import Token from '@/utils/Token.js';

export default {
    components: {
        Card,
        FloatLabel,
        InputText,
        Password,
        Button,
    },
    data() {
        return {
            form: {},
            errors: {},
            isLoading: false,
        }
    },
    mounted() {
        this.form.token = this.$route.params.token;
    },
    methods: {
        login(form) {
            this.errors = {};
            this.isLoading = true;

            Auth.alterarSenha(form)
                .then(response => {
                    this.$toast.add({ severity: 'success', summary: 'Sucesso!', detail: `Sua senha foi alterada com sucesso!`, life: 3000 });
                    this.$router.push('/login');
                })
                .catch(error => {
                    if(error.response) {
                        let err = error.response.data;
                        if(err.erros) {
                            for(let i in err.erros) {
                                this.errors[i] = err.erros[i][0];
                            }
                            return;
                        }
                        if(error.response.data.msg) {
                            this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.response.data.msg, life: 5000 });
                            return;
                        }
                    }
                    this.$toast.add({ severity: 'error', summary: 'Ops!', detail: error.message, life: 5000 });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        },
    },
};
</script>